import React, { useEffect, useMemo, useState } from "react";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import Pagination from "../../common/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import SearchBar from "../../common/SearchBar";
import { getUserById, getUsers } from "../../../services/adminService";
import debounce from "lodash.debounce";
import DetailsModal from "../../common/DetailsModal";
import PopupContent from "./PopupContent";
import { Dropdown } from "antd";
import FilterPanel from "../../common/FilterPanel";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
// Removed fundraiser and merchant filters from User List
import RedeemedOffers from "./RedeemedOffers";

const UserListDataTable = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.adminReducer?.loading);
  const [allUsers, setAllUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [statusToggled, setStatusToggled] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  // Removed fundraiser and merchant search queries for User List
  const [open, setOpen] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  // Removed fundraiser and merchant lists for User List
  const [filterParams, setFilterParams] = useState({
    status: null,
  });

  // Redeemed offer modal state
  const [offerDetailsOpen, setOfferDetailsOpen] = useState(false);
  const [offerDetails, setOfferDetails] = useState(null);

  // Removed fundraiser and merchant debounced searches for User List

  // Removed fundraiser and merchant search handlers

  // Convert filterData to a computed value instead of state
  const filterData = useMemo(
    () => [
      {
        id: "status",
        title: "Subscription Status",
        options: ["Active", "InActive"],
        multiSelect: false,
        valueMap: {
          Active: "active",
          InActive: "inactive",
        },
      },
    ],
    []
  );

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  const [selections, setSelections] = useState(createInitialState(filterData));

  const getUsersData = async (query = "") => {
    console.log('filterParams', filterParams)
    const payload = {
      page: currentPage,
      search: query,
      role: "user",
      status: filterParams?.status,
    };
    console.log('payload', payload)

    const usersPromise = await dispatch(getUsers(payload))?.unwrap();
    if (usersPromise?.success === true) {
      setAllUsers(usersPromise?.data);
      setCurrentPage(usersPromise?.currentPage);
      setTotalPages(usersPromise?.totalPages);
      setCount(usersPromise?.count);
    }
  };

  useEffect(() => {
    getUsersData(searchQuery);
  }, [statusToggled, currentPage, filterParams]);

  const items = [{ title: "Users" }, { title: "User List" }];

  const columns = [
    { name: "No." },
    { name: "Name" },
    { name: "Date Joined" },
    { name: "Email" },
    { name: "Sub. Amount" },
    { name: "Sub. Status" },
    { name: "Actions" },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of user list when changing pages
    const container = document.getElementById('user-list-container');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        getUsersData(query);
      }, 500),
    []
  );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const handleViewDetails = (user) => {
    console.log("View details for user:", user);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Removed cleanup for fundraiser and merchant debounced searches

  const openPopup = async (user) => {
    console.log("Opening popup for user:", user);
    console.log("userId", user?._id);

    if (!user?._id) {
      console.error("No user ID provided");
      return;
    }

    try {
      const userPromise = await dispatch(getUserById({ id: user?._id }))?.unwrap();
      console.log("API response:", userPromise);

      if (userPromise?.success) {
        setUserDetails(userPromise?.data);
        setIsDetailOpen(true);
        return;
      }
      // Fallback: open modal with row data if API didn't return success
      console.log("API didn't return success, using fallback data");
      setUserDetails(user || {});
      setIsDetailOpen(true);
    } catch (error) {
      // Fallback on error (e.g., 500) to avoid blank modal
      console.error("Error fetching user details, showing cached row:", error);
      setUserDetails(user || {});
      setIsDetailOpen(true);
    }
  };

  const closePopup = () => {
    setUserDetails({});
    setIsDetailOpen(false);
  };

  // Removed fundraiser and merchant data fetching and effects for User List

  const handleSelectionChange = (filterId, value) => {
    console.log("handleSelectionChange called");
    console.log("filterData ++>", filterData);
    console.log("filterId ++>", filterId);
    console.log("value ++>", value);
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  const handleReset = () => {
    handleCancel();
    const initialState = createInitialState(filterData);
    setSelections(initialState);
    setFilterParams({
      status: null,
    });
  };

  const handleApply = () => {
    handleCancel();
    console.log("Applying filters:", selections);

    const mappedFilterParams = {};

    filterData.forEach((filter) => {
      const selectedValue = selections[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });
    console.log("Mapped Filter Params:", mappedFilterParams);
    setFilterParams(mappedFilterParams);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  // Callback for PopupContent
  const handleRedeemedOfferClick = (offer) => {
    setIsDetailOpen(false); // Close user modal
    setOfferDetails(offer);
    setOfferDetailsOpen(true); // Open offer details modal
  };

  console.log("userDetails", userDetails);
  return (
    <>
      {loading && <Loader />}
      {isDetailOpen && (
        <DetailsModal
          handleClose={closePopup}
          content={
            <PopupContent
              userDetails={userDetails}
              onRedeemedOfferClick={handleRedeemedOfferClick}
            />
          }
          popupClassName="p-6 w-[335px] sm:w-[540px] md:w-[640px]"
        />
      )}
      {offerDetailsOpen && (
        <DetailsModal
          handleClose={() => {
            setOfferDetailsOpen(false);
            setIsDetailOpen(true); // Re-open parent modal
          }}
          content={<RedeemedOffers offerDetails={offerDetails} />}
          popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
        />
      )}
      <div className="flex flex-col gap-[1rem] md:gap-0 md:flex-row items-start md:items-center justify-between col-span-12">
        <BreadCrumsHeader heading="User List" items={items} search={true} />
        {/* <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full mt-[4%] p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        /> */}
      </div>
      <div className="w-full flex justify-between items-center mt-4">
        <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
        <Dropdown
          overlay={
            <FilterPanel
              filterData={filterData}
              selections={selections}
              handleApply={handleApply}
              handleCancel={handleCancel}
              handleReset={handleReset}
              handleSelectionChange={handleSelectionChange}
            />
          }
          trigger={["click"]}
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomRight"
          overlayStyle={{
            minWidth: "320px",
            maxHeight: "80vh",
            zIndex: 1000,
          }}
          overlayClassName="filter-dropdown-overlay"
        >
          <button className="flex justify-center items-center gap-2 border border-[#00ADEF] rounded-md p-3 text-lg font-medium outline-none h-[40px]">
            <div className="flex items-center gap-2">
              <FiltersIcon className="w-[20px] h-[20px]" />
              <span className="font-[500] text-[14px] font-poppins leading-[22px]">
                Filters
              </span>
            </div>
            <DownArrow />
          </button>
        </Dropdown>
      </div>
      <div id="user-list-container" className="col-span-12 mt-8">
        <TableContainer style={{ width: "100%", overflowX: "auto" }}>
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns.map((column, index) => (
                  <TableCell key={index} className="!text-[#FFFFFF]">
                    {column.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {allUsers.map((user, index) => (
                <TableRow
                  key={index}
                  className="h-[50px]"
                  sx={{
                    boxShadow: "0px 4px 4px 0px #00000040",
                    backgroundColor:
                      (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                  }}
                >
                  <TableCell>{(currentPage - 1) * 50 + index + 1}</TableCell>
                  <TableCell>{user?.name}</TableCell>
                  <TableCell>{formatDate(user?.createdAt)}</TableCell>
                  <TableCell>{user?.email}</TableCell>
                  <TableCell>${user?.subscriptionAmount || "0"}</TableCell>
                  <TableCell>
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium border-[0.5px] ${user?.subscriptionStatus
                          ? "bg-[#50CD8933] text-[#303033] border-[#50CD89]"
                          : "bg-[#BABABA33] text-[#303033] border-[#B1B1B1]"
                        }`}
                    >
                      {user?.subscriptionStatus ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                  <TableCell>
                    <button
                      className={`flex justify-center items-center border rounded-[6px] p-3 h-[34px] border-[#00ADEF] text-[#00ADEF]`}
                      onClick={() => openPopup(user)}
                    >
                      <span className="font-[600] text-[14px] font-poppins leading-[22px]">
                        View Details
                      </span>
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default UserListDataTable;
